<template>
	<div>
		<new-page-gen :options="options" />
	</div>
</template>

<script>
import NewPageGen from './NewPageGen.vue'

const config = {
	options: {
		resource: 'order-tag-keys'
	}
}

export default {
	name: 'OrderTagKeysNew',
	components: { NewPageGen },
	data: () => config
}
</script>
